export const home = [
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/home/index.vue"),
    meta: {
      title: "首页",
      menuId: "1861283974676426752",
      icon: "shangpin",
    },
  },
];
// 按钮code映射
export const productsBtnMap = {
  productExport_76426757: "1861283974676426757", // 商品管理-导出
};
